import { LanguageProvider } from "./context/LanguageContext";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Products from "./components/Products";
import Mission from "./components/Mission";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import "@/App.css";

function App() {
  return (
    <LanguageProvider>
      <div className="min-h-screen bg-[var(--bg-base)] text-[var(--text-primary)]">
        <Header />
        <main>
          <Hero />
          <Products />
          <Mission />
          <Contact />
        </main>
        <Footer />
        <CookieBanner />
      </div>
    </LanguageProvider>
  );
}

export default App;
